import { Dispatch } from 'react';
import { DeckAction, DeckState } from '../context/DeckContextV3';
import { Block, Edge, Segment } from 'src/types/shared/blocksV3';
import {
	getDefaultLanding,
	getDefaultLandingForSegment,
} from './getDefaultLandingV3';

const handleAddLanding = ({
	state,
	dispatch,
	block,
	edge,
	isIntermediate,
	segment,
}: {
	state: DeckState;
	dispatch: Dispatch<DeckAction>;
	block: Block;
	edge: Edge;
	isIntermediate?: boolean;
	segment?: Segment;
}) => {
	const data = segment
		? getDefaultLandingForSegment({
				parentBlock: block,
				selectedBlockEdge: edge,
				selectedBlockSegment: segment,
			})
		: getDefaultLanding({
				blocks: state.blocks,
				parentBlock: block,
				selectedBlockEdge: edge,
			});

	if (!data) {
		return;
	}

	const defaultLanding = data.defaultLanding;
	const newSegment = data.newSegment;
	const updatedOldSegment = data.updatedOldSegment;

	if (defaultLanding && updatedOldSegment) {
		const updatedBlock = { ...block };

		updatedBlock.edges = updatedBlock?.edges.map((ed) => {
			if (ed.id == edge.id) {
				const updatedEdge = { ...ed };

				updatedEdge.segments = updatedEdge.segments.map((seg) => {
					if (seg.id == updatedOldSegment.id) {
						return { ...updatedOldSegment };
					}
					return seg;
				});

				if (newSegment?.length) {
					updatedEdge.segments = [...updatedEdge.segments, newSegment];
				}

				return updatedEdge;
			} else {
				return ed;
			}
		});

		dispatch({
			type: 'UPDATE_BLOCK',
			payload: updatedBlock,
		});

		dispatch({
			type: 'ADD_LANDING',
			payload: defaultLanding,
		});

		if (!isIntermediate) {
		}

		return defaultLanding.id;
	} else {
		return;
	}
};

export default handleAddLanding;
